import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Modal from '../../../../FlyfishComponents/Modal';
import Axios from 'axios';
import { loadStateSession } from '../../../../FlyfishComponents/flyfishutils/utils';
import Button from '../../../../FlyfishComponents/Button';
import { MicEcom } from '../../../../FlyfishComponents/flyfishIcons/icons';
import { getImg } from '../../../../../Utils/getImg';
import Loader from '../LoaderCard/lotties-for-loaders/loader.json';
import lottieLight from 'lottie-web/build/player/lottie_light.min.js';
interface BlobEvent extends Event {
	readonly data: Blob;
}
interface MediaRecorderOptions {
	mimeType?: string;
	audioBitsPerSecond?: number;
	videoBitsPerSecond?: number;
	bitsPerSecond?: number;
}

interface MediaRecorder {
	readonly state: 'inactive' | 'recording' | 'paused';
	readonly stream: MediaStream;
	readonly videoBitsPerSecond: number;
	readonly audioBitsPerSecond: number;
	readonly bitsPerSecond: number;
	readonly mimeType: string;
	ondataavailable: (this: MediaRecorder, ev: BlobEvent) => any;
	onerror: (this: MediaRecorder, ev: Event) => any;
	onpause: (this: MediaRecorder, ev: Event) => any;
	onresume: (this: MediaRecorder, ev: Event) => any;
	onstart: (this: MediaRecorder, ev: Event) => any;
	onstop: (this: MediaRecorder, ev: Event) => any;

	pause(): void;
	requestData(): void;
	resume(): void;
	start(timeslice?: number): void;
	stop(): void;
}

declare var MediaRecorder: {
	prototype: MediaRecorder;
	new(stream: MediaStream, options?: MediaRecorderOptions): MediaRecorder;
};
interface AudioRecorderProps {
	onTranscription: (transcription: string) => void;
	recordVoice: boolean;
	initialDelayComplete: boolean;
}

const VoiceContent = styled.div`
	.modal-overlay-bot .modal-container-bot {
		width: fit-content;
		height: fit-content;
		padding: 24px;
		border-radius: 20px;
		min-width: 600px;

		@media (max-width: 600px) {
			min-width: unset;
			border-radius: 20px 20px 0px 0px;
			width: 89vw;
		}
		header {
			position: relative;
			.top-close {
				position: absolute;
				top: -21px;
				right: -17px;
			}
		}
		.ff-listening {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.ff-chatbot-h5 {
				color: var(--primary-color-ff-primary900);
				line-height: 32px;
				letter-spacing: 0.48px;
			}
			.showLoading {
				border-radius: 100px;
				display: flex;
				position: relative;
				width: 160px;
			}
		}

		.ff-mic-content {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			.ff-mic-icon {
				background-color: rgba(255, 244, 249, 1);
				display: flex;
				padding: 9px;
				align-items: center;
				gap: 15px;
				border-radius: 50%;
				margin-bottom: 12px;
				> div {
					&:nth-of-type(1) {
						background-color: rgba(253, 195, 229, 0.5);
						display: flex;
						border-radius: 50%;
						align-items: center;
						padding: 9px;
						> div {
							background-color: rgba(253, 195, 229, 1);
							border-radius: 50%;
							display: flex;
							padding: 4px;
							align-items: center;
						}
					}
				}
			}
			.ff-chatbot-body1 {
				color: var(--primary-color-ff-primary900);
				font-size: 16px;
				text-align: center;
			}
			.custom-button {
				margin-top: 24px;
				.MuiButton-sizeSmall {
					padding: 5px 16px;
					height: unset;
					gap: 4px;
					border-radius: 25px;
				}
			}
		}
	}
`;
const VoiceModal = ({ id, voiceText, botId, tenantId }) => {
	const [isListening, setIsListening] = useState(false);
	const [seconds, setSeconds] = useState(0);
	const visualizationRef = useRef(null);
	const listeningStatusRef = useRef(null);
	const [isRecording, setIsRecording] = useState(false);
	const durationRef = useRef(null);
	const convertingRef = useRef(null);
	const micControlsRef = useRef(null);
	const animationIdRef = useRef<number | null>(null);
	const audioContextRef = useRef<AudioContext | null>(null);
	const analyserRef = useRef<AnalyserNode | null>(null);
	const dataArrayRef = useRef<Uint8Array | null>(null);
	const bufferLengthRef = useRef<number>(0);
	const intervalIdRef = useRef<number | null>(null);
	const [converting, isShowConverting] = useState(false);
	const [micAllowed, isMicAllowed] = useState(false);
	const [listeningStatus, setListeningStatus] = useState('Listening');
	const [maxDurationReached, setMaxDuration] = useState(false);
	const [micState, setMicState] = useState('');
	const [isMicDenied, setisMicDenied] = useState(false);
	const mediaRecorderRef = useRef<MediaRecorder | null>(null);
	const audioChunksRef = useRef<Blob[]>([]);
	const loaderRef = useRef(null);
	useEffect(() => {
		checkMicPermission();
		return () => {
			if (audioContextRef.current) audioContextRef.current.close();
		};
	}, []);
	useEffect(() => {
		let loaderInstance;

		if (loaderRef.current) {
			let colorArray = [
				'secondary-color-ff-secondary200',
				'none',
				'secondary-color-ff-secondary400',
				'none',
				'primary-original-color',
				'none',
				'primary-color-ff-primary400',
				'none',
				'secondary-color-ff-secondary200',
				'none',
			];
			loaderInstance = lottieLight.loadAnimation({
				container: loaderRef.current,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData: Loader,
			});
			const svgElement = loaderRef.current.querySelector('svg');
			const paths = svgElement.querySelectorAll('path');
			// Assign colors to individual paths based on index
			paths.forEach(function (path, index) {
				if (colorArray[index]) {
					path.setAttribute('fill', `var(--${colorArray[index]})`); // Assign color to path by index
				}
			});
		}
	}, [loaderRef, micState]);

	const checkMicPermission = async () => {
		const userAgent = navigator.userAgent;
		if (!userAgent.includes('Firefox')) {
			const permissionStatus = await navigator.permissions.query({
				//@ts-ignore
				name: 'microphone',
			});

			// Handle different permission states
			if (permissionStatus.state === 'granted') {
				// props.micAllowed()
				startRecording();
				setIsRecording(true);
				setIsListening(true);
				setMicState('granted');
				console.log('Microphone permission granted');
			} else if (permissionStatus.state === 'denied') {
				setMicState('Denied');
				console.log('Microphone permission denied');
			} else if (permissionStatus.state === 'prompt') {
				setMicState('prompt');
				console.log('Microphone permission prompt');
			}
		} else {
			// await requestMicrophoneAccess();
		}
	};
	async function requestMicrophoneAccess() {
		//startRecording();

		try {
			setTimeout(() => {
				if (!isMicDenied) {
					setIsRecording(true);
					setIsListening(true);
				}
			}, 200);

			const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
			startRecording();
			setIsRecording(true);
			setIsListening(true);
		} catch (err) {
			console.log('Microphone permission denied');

			setisMicDenied(true);
		}
	}

	const startRecording = async () => {
		// If there is an active recording, stop it first

		//checkMicPermission();

		if (mediaRecorderRef.current) {
			if (mediaRecorderRef.current.state !== 'inactive') {
				mediaRecorderRef.current.stop();
			}
			// Cleanup the previous stream
			mediaRecorderRef.current.stream
				.getTracks()
				.forEach((track) => track.stop());
		}

		// Reset state
		audioChunksRef.current = [];

		// Get a new media stream
		try {
			const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

			// Create a new MediaRecorder instance
			if (stream.active) {
				setTimeout(() => {
					setSeconds(1);
					intervalIdRef.current = window.setInterval(() => {
						//s  updateTime();
					}, 1000) as unknown as number;
				}, 100);
				const options = { mimeType: 'audio/webm' };
				mediaRecorderRef.current = new MediaRecorder(stream, options);

				// Set up the new MediaRecorder instance
				mediaRecorderRef.current.ondataavailable = (event) => {
					console.log(event);
					audioChunksRef.current.push(event.data);
				};

				mediaRecorderRef.current.onstop = async () => {
					const audioBlob = new Blob(audioChunksRef.current, {
						type: mediaRecorderRef.current?.mimeType,
					});
					audioChunksRef.current = [];
					await transcribeAudio(audioBlob);
				};

				// Start recording
				mediaRecorderRef.current.start();
				// Set up silence detection
				const audioContext = new AudioContext();
				const analyser = audioContext.createAnalyser();
				const source = audioContext.createMediaStreamSource(stream);
				source.connect(analyser);
				const bufferLength = analyser.frequencyBinCount;
				const dataArray = new Uint8Array(bufferLength);
				analyserRef.current = analyser;
				dataArrayRef.current = dataArray;
				audioContextRef.current = audioContext;
				setTimeout(() => {
					checkForSilence(analyser, stopRecording);
				}, 3000);
			}
		} catch (err) {
			//  props.stopListening();
		}
	};
	const convertSpeechToText = (base64) => {
		const payload = {
			id: id,
			message: '',
			botId: botId,
			version: 'prod',
			country: loadStateSession('FS-country'),
			metaData: {},
			source: 'web',
			agent_chat: false,
			redirect: '',
			audio_src: base64,
		};

		Axios.post(`${window['BASE_URL']}/conversation/voice_message`, payload, {
			headers: {
				'Content-Type': 'application/json',
				'x-tenant-id':
					loadStateSession('tenantId') ??
					loadStateSession('tenantID') ??
					tenantId,
				'Authorization': `Bearer ${loadStateSession('token')}`
			},
		})
			.then((response) => {
				isShowConverting(false);
				//   setMaxDuration(false);
				// console.log(response);
				voiceText(response.data[0].message);
			})
			.catch((error) => {
				//props.stopListening();
			});
	};

	const stopRecording = () => {
		setMicState('processing');
		if (mediaRecorderRef.current) {
			if (mediaRecorderRef.current.state !== 'inactive') {
				mediaRecorderRef.current.stop();
			}
			// Cleanup the stream
			mediaRecorderRef.current.stream
				.getTracks()
				.forEach((track) => track.stop());
			mediaRecorderRef.current = null; // Clear reference
		}
		isShowConverting(true);
		cancelAnimationFrame(animationIdRef.current);
		audioContextRef && audioContextRef.current.close();
		clearInterval(intervalIdRef.current);
		setIsListening(false);

		// onInitialDelayComplete(false);
	};
	const convertBlobToBase64 = (blob: Blob): Promise<string> => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => {
				resolve((reader.result as string).split(',')[1]); // Get the base64 string only
			};
			reader.onerror = reject;
			reader.readAsDataURL(blob);
		});
	};
	const SILENCE_THRESHOLD = 200; // Adjust this value (0 to 255) to detect silence (lower values are more sensitive)
	const SILENCE_DELAY = 3000; // 3 seconds of silence before stopping

	let silenceStartTime: number | null = null;
	const checkForSilence = (
		analyser: AnalyserNode,
		stopRecording: () => void
	) => {
		const dataArray = new Uint8Array(analyser.frequencyBinCount);

		const detectSilence = () => {
			analyser.getByteTimeDomainData(dataArray);

			// Calculate the average amplitude of the signal
			const amplitude =
				dataArray.reduce((sum, value) => sum + Math.abs(value - 128), 0) /
				dataArray.length;

			if (amplitude < SILENCE_THRESHOLD) {
				// Start counting silence time
				if (silenceStartTime === null) {
					silenceStartTime = Date.now();
				} else if (Date.now() - silenceStartTime > SILENCE_DELAY) {
					// Silence has been detected for the specified delay, stop recording
					console.log('Silence detected, stopping recording...');
					stopRecording();
				}
			} else {
				// Reset silence detection if there is audio input
				silenceStartTime = null;
			}

			// Continue checking for silence
			if (
				mediaRecorderRef.current &&
				mediaRecorderRef.current.state === 'recording'
			) {
				requestAnimationFrame(detectSilence);
			}
		};

		detectSilence();
	};

	const transcribeAudio = async (audioBlob: Blob) => {
		const base64 = await convertBlobToBase64(audioBlob);
		convertSpeechToText(base64);
	};

	return (
		<VoiceContent>
			<Modal
				headerCloseBtn={false}
				footerNotReq={true}
				onClose={() => voiceText('')}
				headerCloseBtnIcon={
					micState !== 'granted' &&
					micState !== 'processing' && (
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='29.255'
							height='29.25'
							viewBox='0 0 29.255 29.25'
						>
							<g
								id='Icon_ion-ios-close-outline'
								data-name='Icon ion-ios-close-outline'
								transform='translate(-3.372 -3.375)'
							>
								<path
									id='Path_20510'
									data-name='Path 20510'
									d='M28.343,7.657a14.627,14.627,0,1,0,0,20.686,14.632,14.632,0,0,0,0-20.686Zm-.865,19.821a13.4,13.4,0,1,1,0-18.956A13.423,13.423,0,0,1,27.478,27.478Z'
								/>
								<path
									id='Path_20511'
									data-name='Path 20511'
									d='M23.92,11.25l-5.934,5.92L12.08,11.278l-.83.83L17.156,18,11.25,23.892l.83.83,5.906-5.892,5.934,5.92.83-.83L18.816,18l5.934-5.92Z'
								/>
							</g>
						</svg>
					)
				}
			>
				{micState == 'prompt' ? (
					<div className='ff-mic-content'>
						<div className='ff-mic-icon'>
							<div>
								<div>
									<svg
										width='36'
										height='36'
										viewBox='0 0 36 36'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<g id='mic'>
											<mask
												id='mask0_421_22092'
												style={{ maskType: 'alpha' }}
												maskUnits='userSpaceOnUse'
												x='0'
												y='0'
												width='36'
												height='36'
											>
												<rect
													id='Bounding box'
													width='36'
													height='36'
													fill='#D9D9D9'
												/>
											</mask>
											<g mask='url(#mask0_421_22092)'>
												<path
													id='mic_2'
													d='M17.9996 21C16.7496 21 15.6871 20.5625 14.8121 19.6875C13.9371 18.8125 13.4996 17.75 13.4996 16.5V7.5C13.4996 6.25 13.9371 5.1875 14.8121 4.3125C15.6871 3.4375 16.7496 3 17.9996 3C19.2496 3 20.3121 3.4375 21.1871 4.3125C22.0621 5.1875 22.4996 6.25 22.4996 7.5V16.5C22.4996 17.75 22.0621 18.8125 21.1871 19.6875C20.3121 20.5625 19.2496 21 17.9996 21ZM16.4996 30V26.8875C14.1996 26.5625 12.2309 25.5875 10.5934 23.9625C8.95587 22.3375 7.96212 20.3625 7.61212 18.0375C7.56212 17.6125 7.67462 17.25 7.94962 16.95C8.22462 16.65 8.57462 16.5 8.99962 16.5C9.42462 16.5 9.78087 16.6438 10.0684 16.9313C10.3559 17.2188 10.5496 17.575 10.6496 18C10.9996 19.75 11.8684 21.1875 13.2559 22.3125C14.6434 23.4375 16.2246 24 17.9996 24C19.7996 24 21.3871 23.4312 22.7621 22.2938C24.1371 21.1562 24.9996 19.725 25.3496 18C25.4496 17.575 25.6434 17.2188 25.9309 16.9313C26.2184 16.6438 26.5746 16.5 26.9996 16.5C27.4246 16.5 27.7746 16.65 28.0496 16.95C28.3246 17.25 28.4371 17.6125 28.3871 18.0375C28.0371 20.3125 27.0496 22.275 25.4246 23.925C23.7996 25.575 21.8246 26.5625 19.4996 26.8875V30C19.4996 30.425 19.3559 30.7812 19.0684 31.0687C18.7809 31.3562 18.4246 31.5 17.9996 31.5C17.5746 31.5 17.2184 31.3562 16.9309 31.0687C16.6434 30.7812 16.4996 30.425 16.4996 30Z'
													fill='#501ACE'
												/>
											</g>
										</g>
									</svg>
								</div>
							</div>
						</div>
						<div className='ff-chatbot-body1'>
							To enable voice search, please allow Flyfish Fashion to access
							your microphone.
						</div>
						<Button
							onClick={() => {
								startRecording();
								setIsRecording(true);
								setIsListening(true);
							}}
						>
							Allow access
						</Button>
					</div>
				) : micState === 'granted' ? (
					<div className='ff-listening'>
						<div className='ff-chatbot-h5'>Listening</div>
						<img src={getImg('listening.gif')} width={'100'} />
					</div>
				) : micState == 'processing' ? (
					<div className='ff-listening'>
						<div className='ff-chatbot-h5'>Processing voice input</div>
						<div className='showLoading' ref={loaderRef}></div>
					</div>
				) : null}
			</Modal>
		</VoiceContent>
	);
};

export default VoiceModal;
